'use strict'

import axios from 'axios'
import Config from '../config/app'

export const check = async (data, checkPointId) => {
  const params = Object.assign(data, { checkPointId })
  const response = await axios.get(Config.services.checkFastPass, { params})

  return response.data
}
